export default __webpack_public_path__ + "img/soundRadio.af8c7db6.svg";